<script>
  import './style.scss';
  import template from './template.html';
  import { InformationOutlineIcon, ChevronDownIcon } from '../../icons.js';
  //import showContentPage from '../show-content-page';
  import { getterSetterOrderDetailsValue } from './getter-setter';
  import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
  import moment from 'moment';
  import {isEmpty} from 'lodash';

  export default {
    template,

    props: {

      editMode: {
        type: Boolean,
        default: false
      },

      programsEnabled: {
        type: Boolean,
        default: false
      },

      isProgramMandatory: {
        type: Boolean,
        default: false
      },

      orderId: {
        type: [String, Number],
        default: 0
      },

      order: Object,

      options: {
        type: Object,
        default: {
          tags: [],
          types: [],
          order_numbers: [],
          programs: [],
          po_required: 0,
          order_type_required: 0,
          tag_settings: {},
          tag_required: false,
          default_order_type: {}
        }
      }
    },

    methods: {

      ...mapActions('CreateOrderStore', [
        'updateOrderDetailsValue',
        'updateOrderName',
      ]),

      /**
       * Add order to a program and
       * return the new order
       *
       * @param string|Int programId
       *
       * @return Promise programOrder
       */
      generateProgramsOrder (programId) {
        let {behalf_account, behalf_user } = this.coStore.onBehalf;

        const params = {};

        // Check if behalf information is available
        if (behalf_account && behalf_user) {
          params.behalf_account = behalf_account;
          params.behalf_user = behalf_user;
        }

        return axios
          .get(`/programs/generate-order/${programId}`, { params })
          .then(result => result.data);
      },

      /**
       * Select a new program
       *
       * @param Integer programId
       */
      selectProgram (programId) {
        EventBus.$emit('loader:show');

        this.$emit('program-selected');

        this.$nextTick(() => {
          //create a new program order
          this.generateProgramsOrder(programId).then(orderId => {
            EventBus.$emit('loader:hide');

            //go to new order
            window.location = `/orders/view/${orderId}`;
          })
        });
      },

      /**
       * Get todays date
       *
       * @return string
       */
      getCurrentDate () {
        return moment().format('YYYY-MM-DD');
      },

      /**
       * Add a new tag
       *
       * @param string tag
       */
      onTag(tag) {
        if (this.detailsTags.indexOf(tag) < 0) {
          //add to tags options list
          this.options.tags.push({label: tag, value: 9999});

          //add tag to users order
          this.tags.push(tag);
        }
      },

      /**
       * Check if multiple tags are allowed
       *
       * @return Boolean
       */
      allowMultipleTags () {
        let { has_limited_tags, allow_multiple_tags } = this.options.tag_settings;

        return has_limited_tags && !allow_multiple_tags ? false : true;
      },

      /**
       * check if the account has restricted available tags
       *
       * @return Boolean
       */
      hasLimitedTags () {
        return this.options.tag_settings.has_limited_tags;
      },

      confirmProgramModal () {
        if (!this.applyProgramDialogCount && this.isEmptyProgram) {
          this.$modal.show('dialog', {
            title: `<h2 style="margin:0;padding:0;font-weight:300" class="align-text-center">Applying a Program</h2>`,
            text: `Applying a program will <strong>override any existing information</strong> you've entered.`,
            buttons: [
              {
                title: 'OK',
                class: 'vue-dialog-button reviewer-dialog-btn close-btn',
                handler: () => {
                  this.$modal.hide('dialog')
                }
              }
            ]
          });

          this.applyProgramDialogCount++;
        }
      },
    },

    computed: {
      ...mapState({
        coStore: state => state.CreateOrderStore,
      }),

      ...mapState({
        quote: state => state.CreateOrderStore.orderDetails.quote,
        uploadFileType: state => state.CreateOrderStore.orderDetails.uploadFileType,
      }),

      ...mapGetters('AuthStore', [
        'isAdminUser',
      ]),

      //order details params
      name: getterSetterOrderDetailsValue('name'),
      due_at: getterSetterOrderDetailsValue('due_at'),
      purchase_order_number: getterSetterOrderDetailsValue('purchase_order_number'),
      type: getterSetterOrderDetailsValue('type'),
      tags: getterSetterOrderDetailsValue('tags'),
      quote: getterSetterOrderDetailsValue('quote'),
      program: getterSetterOrderDetailsValue('program'),
      auto_approve: getterSetterOrderDetailsValue('auto_approve'),
      auto_approve_amount: getterSetterOrderDetailsValue('auto_approve_amount'),


      /**
       * An array of program names and id's
       *
       * @return array
       */
      programs () {
        let programs = this.options.programs;

        return Object.keys(programs).map((program) => {
          return { label: programs[program], value: program };
        })
      },

      /**
       * Get a list of tag names for 'order details' section
       *
       * @return array
       */
      detailsTags () {
        return this.options.tags.map(tag => tag.label)
      },

      /**
       * Check if the user has set a program
       *
       * @return Boolean
       */
      isEmptyProgram () {
        return isEmpty(this.program);
      },
    },

    data () {
      let selected = Object.assign({}, this.selected);

      return {
        applyProgramDialogCount: 0,
      }
    },

    components: {
      InformationOutlineIcon,
      ChevronDownIcon,
    },
  }
</script>
